export const actionTypes = {
    GET_RESTAURANT: 'GET_RESTAURANT',
    SET_RESTAURANT_INFO: 'SET_RESTAURANT_INFO',
    UPDATE_RESTAURANT_INFO: 'UPDATE_RESTAURANT_INFO',
    VERIFY_TABLE: 'VERIFY_TABLE',
    REQUEST_TABLE: 'REQUEST_TABLE',
    REQUEST_TABLE_SUCCESS: 'REQUEST_TABLE_SUCCESS',
    RETRY_REQUEST_TABLE: 'RETRY_REQUEST_TABLE',
    CHECK_TABLE_STATUS: 'CHECK_TABLE_STATUS',
    CHECK_TABLE_STATUS_SUCCESS: 'CHECK_TABLE_STATUS_SUCCESS',
}

export const getRestaurantInfo = payload => ({
    type: actionTypes.GET_RESTAURANT,
    payload,
})

export const verifyTable = payload => ({
    type: actionTypes.VERIFY_TABLE,
    payload,
})

export const requestTable = payload => ({
    type: actionTypes.REQUEST_TABLE,
    payload,
})

export const retryRequestTable = payload => ({
    type: actionTypes.RETRY_REQUEST_TABLE,
    payload,
})

export const checkTableStatus = payload => ({
    type: actionTypes.CHECK_TABLE_STATUS,
    payload,
})
